import React, { useEffect, useState, useContext } from "react";
import InputMultiSelect from "../../components/modalComponents/InputMultiSelect";
import { AuthContext } from "../../hooks/context/authContext";
import { useSubmitForm } from "../../hooks/useSubmitForm/useSubmitForm";
import { usePropsSelect } from "../../hooks/useProps/usePropsSelect";
import { usePostRequest } from "../../hooks/usePostRequest/usePostRequest";
import { useGetRequest } from "../../hooks/useGetRequest/useGetRequest";
import { initialAllOptionPromises } from "../../helper/utils";
import { downloadFile } from "../../consumers/backendConsumer";
import { mostrarMensajeDeErrorConToast, responseCode200 } from "../../consumers/httpRequiestsUtils";
import {
  deleteFileFromS3API,
  getPeriodosForFiltroListarFaltasAPI,
  downloadReporteFaltasPorPeriodosAPI,
  getSedesByUserRoleAPI,
} from "../../consumers/backendApisUrls";

const ReporteFaltasPorPeriodos = () => {
  const SECTION_NAME = "ReporteFaltasPorPeriodos";
  const INIT_KEYS = { periodos: "IdsFaltaPeriodo", sedes: "IdsSedes" };

  const { state } = useContext(AuthContext);

  const [formValues, setFormValues] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [loading, setLoading] = useState(false);

  const [executePostRequest] = usePostRequest();
  const [executeGetRequest] = useGetRequest();
  const [submitForm] = useSubmitForm();
  const [selectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);

  const initialPromises = () => {
    return [
      (async () => {
        const res = await executeGetRequest(getPeriodosForFiltroListarFaltasAPI());
        if (responseCode200(res)) {
          return res.data.map(o => ({ value: o.IdFaltaPeriodo, label: o.Nombre }));
        }
        return [];
      })(),
      (async () => {
        const res = await executeGetRequest(getSedesByUserRoleAPI());
        if (responseCode200(res)) {
          return [{value: 0, label: 'Todos'}, ...res.data.map(o => ({ value: o.Value, label: o.Text }))];
        }
        return [];
      })(),
    ];
  };

  const init = async () => {
    await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), updateFormValues);
  };

  const updateFormValues = (data) => {
    setAllDropdowns(data);
  };

  const handleDescargarReporte = async () => {
    setLoading(true);
    try {
      const api = downloadReporteFaltasPorPeriodosAPI();
      const sedes = formValues[INIT_KEYS.sedes] || [];
      const payload = {
        idsFaltaPeriodo: formValues[INIT_KEYS.periodos] || [],
        idsSedes: sedes.includes(0) ? [] : sedes,
      };
      await submitForm(Object.values(INIT_KEYS), api, payload, SECTION_NAME, successDescargarReporteCallback);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const successDescargarReporteCallback = async (res) => {
    let data = res.data;
    let reporte = await downloadFile(state.token, data?.FilePath, data?.OriginalFileName);
    if (responseCode200(reporte)) {
      await eliminarArchivoDeS3(data?.FilePath);
    } else {
      mostrarMensajeDeErrorConToast(reporte);
    }
  };

  const eliminarArchivoDeS3 = async function (filePath) {
    let deleteFileFromS3Payload = {
      Path: filePath,
    };
    let deleteFileFromS3Response = await executePostRequest(deleteFileFromS3API(), deleteFileFromS3Payload);
    if (responseCode200(deleteFileFromS3Response)) {
      console.debug("delete file from s3 successfully");
    } else {
      mostrarMensajeDeErrorConToast(deleteFileFromS3Response);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="card-body">
      <div id={SECTION_NAME}>
        <Div>
          <InputMultiSelect
            label="Períodos"
            isRequired
            {...selectProps(INIT_KEYS.periodos, [], true)}
          />
        </Div>
        <Div>
          <InputMultiSelect
            label="Sedes"
            {...selectProps(INIT_KEYS.sedes, [], true)}
          />
        </Div>
      </div>
      <div className="reporte-datos-generales-dato-obligatorio">
        <p>
          (<span className="required">*</span>) Dato obligatorio
        </p>
      </div>
      <div className="ml-2">
        <button
          className="btn btn-primary generic-button-ficha"
          onClick={handleDescargarReporte}
          disabled={loading}
        >
          {loading ? "Descargando" : "Descargar"} Reporte {loading ? "..." : ""}
        </button>
      </div>
    </div>
  );
};

export default ReporteFaltasPorPeriodos;

const Div = ({ children }) => <div className="col-sm-6">{children}</div>;
